import { createPortal } from "react-dom";
import React from "react";

export const DesktopPortal: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const root =
    (typeof document !== "undefined" &&
      document.getElementById("desktop-root")) ||
    document.body;

  return createPortal(children, root!);
};
